import { Component, OnInit, Input } from "@angular/core";
import { FranchiseService } from "../franchise/franchise.service";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "../../../../core/custom-validators";
import { Router } from "@angular/router";

@Component({
  selector: "app-provider",
  templateUrl: "./provider.component.html",
  styleUrls: ["./provider.component.css"],
})
export class ProviderComponent implements OnInit {
  formbuilder: any;
  formGroup: any;
  providerData: Provider = new Provider();
  providerForm: UntypedFormGroup;
  formgroup: UntypedFormGroup;
  completionPage: boolean;
  today: Date;
  allStates = [];
  dateFormat = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private service: FranchiseService
  ) {}

  public radioBtnOptions = [
    { value: "Increased", display: "Increased" },
    { value: "Decreased", display: "Decreased" },
    { value: "No Change", display: "No Change" },
    { value: "Other", display: "Other  (Briefly explain below)" },
  ];

  public radioBtn1Options = [
    // Not sure option Added
    { value: "0", display: "0" },
    { value: "1", display: "1" },
    { value: "2", display: "2" },
    { value: "3", display: "3" },
    { value: "4", display: "4" },
    { value: "Not Sure", display: "Not Sure" },
  ];

  public yesNoOptions = [
    { value: "Yes", display: "Yes" },
    { value: "No", display: "No" },
  ];

  public paidOptions = [
    { value: "Yes", display: "Yes" },
    { value: "No", display: "No" },
    { value: "N/A", display: "N/A" },
  ];
  public surveyOptions = [
    { value: "Yes", display: "Yes" },
    { value: "No", display: "No" },
    { value: "Unsure", display: "Unsure" },
  ];
  public mask = "(000) 000-0000";
  ngOnInit() {
    this.providerForm = this.formBuilder.group({
      companyName: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      contactPerson: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      city: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      address1: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      address2: [null],
      zip: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.zipCodeInvalid,
          CustomValidators.noSpace,
        ]),
      ],
      emailId: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.validEmail,
          CustomValidators.noSpace,
        ]),
      ],
      state: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      title: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      phoneNumber: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.PhoneNumberValid,
          CustomValidators.noSpace,
        ]),
      ],
      question1: [
        null,
        [
          this.isIE
            ? Validators.pattern(this.dateFormat)
            : CustomValidators.nativedate,
        ],
      ],
      question2: [null, CustomValidators.numeric],
      question3Comment: null,
      question4: [null, CustomValidators.numeric],
      question5Uniform: [null, CustomValidators.numeric],
      question5Other: [null, CustomValidators.numeric],
      question7a: [null, CustomValidators.numeric],
      question7b: [null, CustomValidators.numeric],
      question7c: [null, CustomValidators.numeric],
      question8a: [null, CustomValidators.numeric],
      question8b: [null, CustomValidators.numeric],
      question8c: [null, CustomValidators.numeric],
      question9a: [null, CustomValidators.numeric],
      question9bComment: null,
      question12: null,
      question13: null,
      question15Desc: [null, CustomValidators.numeric],
      question17Desc: null,
    });
    this.completionPage = false;
    this.today = new Date();
    this.getAllStates();
    this.providerData.companyName = null;
    this.providerData.contactPerson = null;
    this.providerData.address1 = null;
    this.providerData.address2 = null;
    this.providerData.state = null;
    this.providerData.city = null;
    this.providerData.zip = null;
    this.providerData.title = null;
    this.providerData.question1 = null;
    this.providerData.question2 = null;
    this.providerData.question3Comment = "";
    this.providerData.question4 = null;
    this.providerData.question5Uniform = null;
    this.providerData.question5Other = null;
    this.providerData.question7a = null;
    this.providerData.question7b = null;
    this.providerData.question7c = null;
    this.providerData.question8a = null;
    this.providerData.question8b = null;
    this.providerData.question8c = null;
    this.providerData.question9a = null;
    this.providerData.question9bComment = "";
    this.providerData.question11 = "";
    this.providerData.question12 = null;
    this.providerData.question13 = "";
    this.providerData.question14 = "";
    this.providerData.question15 = "";
    this.providerData.question15Desc = null;
    this.providerData.question16 = "";
    this.providerData.question17 = "";
    this.providerData.question17Desc = "";
    this.providerData.Confidential = "";
    this.providerData.question3Comment = null;
    this.providerData.state = "Michigan";
  }

  get isIE() {
    const ua = window.navigator.userAgent;
    return ua.indexOf("Trident") > 0;
  }

  get previousYear() {
    return this.today.getFullYear() - 1;
  }
  get nextYear() {
    return this.today.getFullYear() + 1;
  }
  getAllStates() {
    this.service.GetStates("").subscribe((statesData) => {
      if (statesData) {
        this.allStates = statesData;
      }
    });
  }

  resetQuestion3() {
    if (this.providerData.question3 !== "Other") {
      this.providerData.question3Comment = null;
    }
  }

  resetQuestion7() {
    if (this.providerData.question7 !== "Yes") {
      this.providerData.question7a = null;
      this.providerData.question7b = null;
      this.providerData.question7c = null;
    }
  }

  resetQuestion8() {
    if (this.providerData.question8 !== "Yes") {
      this.providerData.question8a = null;
      this.providerData.question8b = null;
      this.providerData.question8c = null;
    }
  }

  resetQuestion9() {
    if (this.providerData.question9 !== "Yes") {
      this.providerData.question9a = null;
      this.providerData.question9bFranchise = null;
      this.providerData.question9bCompleteness = null;
      this.providerData.question9bPeg = null;
      this.providerData.question9bForm3 = null;
      this.providerData.question9bMapping = null;
      this.providerData.question9bOther = null;
      this.providerData.question9bComment = null;
    }
  }

  checkQuestion9b(checked) {
    if (checked) {
      this.providerData.question9bOther = "Yes";
    } else {
      this.providerData.question9bOther = "No";
      this.providerData.question9bComment = null;
    }
  }

  resetQuestion15() {
    if (this.providerData.question15 !== "Yes") {
      this.providerData.question15Desc = null;
    }
  }
  resetQuestion17() {
    if (this.providerData.question17 !== "Yes") {
      this.providerData.question17Desc = null;
    }
  }

  save() {
    if (
      !this.providerForm.valid ||
      (this.providerData.question15 === "Yes" &&
        !(this.providerData.question15Desc > 0)) ||
      (this.providerData.question3 === "Other" &&
        (this.providerData.question3Comment === "" ||
          this.providerData.question3Comment === "undefined" ||
          this.providerData.question3Comment === null)) ||
      (this.providerData.question9bOther === "Yes" &&
        (this.providerData.question9bComment === "" ||
          this.providerData.question9bComment === "undefined" ||
          this.providerData.question9bComment === null))
    ) {
      Object.keys(this.providerForm.controls).forEach((key) => {
        this.providerForm.get(key).markAsTouched();
      });
    } else {
      this.service.SaveVideoProvider(this.providerData).subscribe((pData) => {
        if (pData) {
          this.completionPage = true;
        } else {
          this.completionPage = false;
        }
      });
    }
  }

  goBack() {
    this.completionPage = false;
    this.providerData = new Provider();
    Object.keys(this.providerForm.controls).forEach((key) => {
      this.providerForm.get(key).markAsUntouched();
    });

    this.ngOnInit();
  }

  Menu() {
    this.router.navigateByUrl("/forms-home");
  }
}

export class Provider {
  companyName: string;
  contactPerson: string;
  address1: string;
  address2: string;
  state: string;
  city: string;
  zip: string;
  title: string;
  emailId: string;
  phoneNumber: string;
  question1: Date;
  question2: number;
  question3: string;
  question3Comment: string;
  question4: string;
  question5Uniform: number;
  question5Other: number;
  question6: string;
  question7: string;
  question7a: number;
  question7b: number;
  question7c: number;
  question8: string;
  question8a: number;
  question8b: number;
  question8c: number;
  question9: string;
  question9a: number;
  question9bFranchise: string;
  question9bCompleteness: string;
  question9bForm3: string;
  question9bPeg: string;
  question9bMapping: string;
  question9bOther: string;
  question9bComment: string;
  question10: string;
  question11: string;
  question12: string;
  question13: string;
  question14: string;
  question15: string;
  question15Desc: number;
  question16: string;
  question17: string;
  question17Desc: string;
  Confidential: string;
}
